import { getCurrencySymbol } from "@features/helpers";

export const CHALLENGE_100K_PAYWALL_STEP = 31;
export const CHALLENGE_100K_DISCOUNT_PAYWALL_STEP = 32;

export const paywall100kFeedbacks = [
    {
        author: "@starter_jess",
        comment:
            "The content is super clear and beginner-friendly. It covers exactly what you need to get started with AI no fluff, just value. Perfect if you're just stepping into this world."
    },
    {
        author: "@echsavvy_omar",
        comment:
            "Tixu.ai provides a huge variety of tools and interactive lessons that break down complex AI concepts into something anyone can grasp. It’s a fresh and modern way to learn AI — props to the creators!"
    },
    {
        author: "@growwithzoe",
        comment:
            "Tixu.ai helped me level up faster than I expected. The personalized approach and easy-to-follow lessons made learning smooth and impactful. I now feel more confident and focused on my next career goals."
    }
];

export const paywall100kBenefits_old = [
    "Learn to create and sell with AI — from art to chatbots",
    "Discover AI tools that save time and make money",
    "Launch AI-powered projects in just 28 days"
];

export const paywall100kBenefits = [
    [
        "Learn to ",
        { text: "create", highlight: true },
        " and ",
        { text: "sell", highlight: true },
        " with AI — from art to chatbots"
    ],
    [
        "Discover AI tools that ",
        { text: "save time", highlight: true },
        " and ",
        { text: "make money", highlight: true }
    ],
    ["Launch AI-powered projects ", { text: "in just 28 days", highlight: true }]
];

export const screenShotes = [
    "/images/onboarding/png/paywall/screen-1.png",
    "/images/onboarding/png/paywall/screen-2.png",
    "/images/onboarding/png/paywall/screen-3.png"
];

export const getPaymentInfo = (
    id: string,
    currency: string,
    priceBefore: number,
    priceAfter: number,
    buttonText: string
) => {
    const currencySymbol = getCurrencySymbol(currency);
    const formatPriceBefore = (priceBefore / 100).toFixed(2);
    const formatPriceAfter = (priceAfter / 100).toFixed(2);
    switch (id) {
        case "9308fc9e-26fe-4b6b-8598-0309d208845a":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "6ae7a950-19b5-407f-aa30-63911e85fa45":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "38b72507-3951-4c49-a6d8-397eaf831f71":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "fa98e923-3688-413c-840c-1fc82ff3e569":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 1-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "51dd6cc6-6c3f-4dd8-b4e1-42376b8c6a66":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 4-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 4 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
        case "1ae4739f-ef2f-41ea-9277-d187b618d338":
            return `By clicking ${buttonText}, you agree to pay ${currencySymbol}${formatPriceBefore} for the first 12-week period and authorize future charges, including automatic renewals at ${currencySymbol}${formatPriceAfter} every 12 weeks and additional purchases made through your account. You can cancel anytime in your account settings.`;
    }
};
